import { render, staticRenderFns } from "./HealthStatus.vue?vue&type=template&id=44447854"
import script from "./HealthStatus.vue?vue&type=script&lang=js"
export * from "./HealthStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports